import { forwardRef } from "react";
import { ReactComponent as TrophyIcon } from "../../../assets/icons/trophy-solid.svg";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const IconTrophy = forwardRef<SVGSVGElement, SvgIconProps>(
  function IconTrophy(props, ref) {
    return (
      <SvgIcon
        ref={ref}
        component={TrophyIcon}
        inheritViewBox
        {...props}
        sx={{ padding: "2px", ...props.sx }}
      />
    );
  },
);

export default IconTrophy;
